import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { Box, Button, Modal, Stack, TextAlpha, useDialogContext, useMediaQueryMatchesOnMobile, } from '@yonderland/andes-react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { useFeatureToggle } from '../../hooks/useFeatureToggle';
import { useOAuth } from '../../hooks/useOAuth';
import { generateTestId } from '../../util/TestUtil';
const TEST_ID = 'security-levels';
const EventOpenSync = () => {
    const { open } = useDialogContext();
    const openRef = useRef(open);
    openRef.current = open;
    useEffect(() => {
        const handler = () => openRef.current();
        EventUtil.listen(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handler);
        return () => EventUtil.remove(EventEnum.USER_SECURITY_LEVEL_TOO_LOW, handler);
    }, []);
    return null;
};
export const SecurityLevelsPopup = () => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const isMobile = useMediaQueryMatchesOnMobile();
    const { root } = useAemConfig();
    const [buttonState, setButtonState] = useState('interactive');
    const { authUrl, logout } = useOAuth();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const handleLogout = () => {
        setButtonState('loading');
        logout();
        window.location.href = isNewAuth ? authUrl : `${root}account.html`;
    };
    return (_jsxs(Modal, { hasCloseBtn: true, fullscreen: isMobile, testId: generateTestId({ testId: TEST_ID, suffix: 'modal' }), children: [_jsxs(Modal.Content, { children: [_jsx(EventOpenSync, {}), _jsx(Box, { paddingBlockEnd: { base: '20', md: '4' }, display: "flex", flex: { grow: 1 }, children: _jsx(TextAlpha, { testId: generateTestId({ testId: TEST_ID, suffix: 'info' }), children: t('account.security.levels.popup.info') }) })] }), _jsx(Modal.Footer, { children: _jsx(Box, { position: isMobile ? 'fixed' : undefined, bottom: isMobile ? '0' : undefined, left: isMobile ? '0' : undefined, right: isMobile ? '0' : undefined, backgroundColor: isMobile ? 'neutral' : undefined, padding: isMobile ? '5' : undefined, children: _jsx(Stack, { justify: "end", children: _jsx(Button, { fullWidth: isMobile, onClick: handleLogout, state: buttonState, testId: generateTestId({ testId: TEST_ID, suffix: 'login-button' }), children: t('account.security.levels.popup.button') }) }) }) })] }));
};
